import { LOYALTY_PACKAGE_STATUS } from "features/LoyaltyPackage/core/constants";
import { useLoyaltyPeriods, useLoyaltyProgram, useSwitchLoyaltyPeriodStatus } from "features/LoyaltyPackage/data/hooks";

const ALL_PERIODS_PAGINATION = { offset: 0, limit: 100 };

export default function useProgramDetail(programId) {
  const { data: program, loading: programLoading, refetch: refetchProgram } = useLoyaltyProgram(programId);

  const {
    data: periodsData,
    loading: periodsLoading,
    refetch: refetchPeriods,
  } = useLoyaltyPeriods(programId ? { loyaltyPackageId: programId } : undefined, ALL_PERIODS_PAGINATION);

  const periods = periodsData?.loyaltyPackagePeriods ?? [];

  const { switchStatus, loading: switchLoading } = useSwitchLoyaltyPeriodStatus();

  const handleSwitchPeriodStatus = async (record, checked) => {
    await switchStatus(record.id, checked);
  };

  const isPeriodEditable = (record) => record.status === LOYALTY_PACKAGE_STATUS.UPCOMING;

  const refetchAll = () => {
    refetchProgram?.();
    refetchPeriods?.();
  };

  return {
    program,
    programLoading,
    periods,
    periodsLoading,
    refetchProgram,
    refetchAll,
    switchLoading,
    handleSwitchPeriodStatus,
    isPeriodEditable,
  };
}
